import { ReactNode } from 'react'

import { PoweredByLabel } from '../../components/widget-components'
import PaytrieWelcomeLeftPanel from './PaytrieWelcomeLeftPanel'
import { DarkModeMenu } from '../signup/DarkmodeSignUpPanel'

const isIframe = window.self !== window.top

type PanelLayoutProps = {
  children: ReactNode
  titleKey: string
}

export const PanelLayout = ({ children, titleKey }: PanelLayoutProps) => {
  const Footer = () => {
    return (
      <div
        data-testid="container-panel-footer"
        className="absolute left-0 right-0 flex justify-center p-2"
        style={{
          top: isIframe
            ? window.innerWidth < 640
              ? '534px'
              : '534px'
            : window.innerWidth < 640
              ? '534px'
              : '660px',
        }}
      >
        <PoweredByLabel />
      </div>
    )
  }

  return (
    <div
      data-testid="container-panel-layout"
      className="flex flex-col md:flex-row gap-4 relative mx-auto"
      style={{
        maxHeight: '100%',

        width: '100%',
      }}
    >
      {window.self == window.top && (
        <div
          data-testid="container-panel-darkmode"
          className="absolute z-50 top-32 right-2 md:top-10 md:right-0"
        >
          <DarkModeMenu />
        </div>
      )}
      <PaytrieWelcomeLeftPanel titleKey={titleKey} />
      <div
        data-testid="container-panel-content"
        className="flex flex-col relative p-10 md:py-24 md:px-4 md:flex-grow"
        style={{}}
      >
        <div data-testid="container-panel-children" className="flex flex-grow">
          {children}
        </div>
        <Footer />
      </div>
    </div>
  )
}
